import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop({ containerRef }) {
  const location = useLocation<{ background?: { pathname: string } } | undefined>()
  // A route opened as a modal keeps the page behind it, and its scroll.
  const pathname = location.state?.background?.pathname ?? location.pathname

  useEffect(() => {
    if (containerRef?.current.scrollTo) {
      containerRef?.current.scrollTo(0, 0)
    }
  }, [pathname, containerRef])

  return null
}
